import { render, staticRenderFns } from "./AnsweredByBotNumberChart.vue?vue&type=template&id=80c27352&"
import script from "./AnsweredByBotNumberChart.vue?vue&type=script&lang=js&"
export * from "./AnsweredByBotNumberChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports